import { createContext, useReducer, useEffect } from "react";
import { THEME_COLORS } from "../constants/CommonConstants";
import { useSelector } from "react-redux";
import { FLAG_CONSTANTS } from "../constants/flagConstants";

export const ThemeContext = createContext();

const ThemesReducer = (state, action) => {
  switch (action.type) {
    case "LIGHT":
      return { ...state, themeChange: THEME_COLORS.LIGHT };
    case "DARK":
      return { ...state, themeChange: THEME_COLORS.DARK };
    case "DEFAULT":
      return { ...state, themeChange: THEME_COLORS.DEFAULT };
    default:
      return state;
  }
};

export const ThemeContextProvider = ({ children }) => {
  const role = localStorage.getItem("role");
  const isSuperAdmin = role === FLAG_CONSTANTS.SUPER_ADMIN_FLAG;

  const { defaultWorkspaceTheme } = useSelector(
    (state) => state?.GetWorkspaceListReducer?.user || {},
  );
  const initialTheme = isSuperAdmin
    ? THEME_COLORS.DEFAULT
    : defaultWorkspaceTheme || THEME_COLORS.DEFAULT;

  const [state, dispatch] = useReducer(ThemesReducer, {
    themeChange: initialTheme,
  });

  useEffect(() => {
    if (defaultWorkspaceTheme && !isSuperAdmin) {
      dispatch({
        type: defaultWorkspaceTheme.toUpperCase() || "DEFAULT", // Handles "default", "light", "dark"
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ThemeContext.Provider value={{ ...state, dispatch }}>
        {children}
      </ThemeContext.Provider>
    </>
  );
};
